<template>
  <stacked-bar-with-prior-year
    :chart-data="chartData"
    :loading="loading"
    chart-v-ax-format="R###,###,###.00"
    v-on:bar-selected="triggerBarSelect"
    :bus="bus"
  ></stacked-bar-with-prior-year>
</template>

<script>
import StackedBar from "../../../charts/StackedBar";
import StackedBarWithPriorYear from "../../../charts/StackedBarWithPriorYear.vue";
import Vue from "vue";

export default {
  name: "ConversionValue",
  data() {
    return {
      loading: false
    }
  },
  props: ['date-range', 'updateData', 'view-data', 'bus'],
  components: {StackedBarWithPriorYear},
  computed: {
    chartData: function() {
      return this.viewData
    }
  },
  methods: {
    triggerBarSelect(event) {
      this.$emit('conversion-bar-selected', event);
    }
  }
}
</script>

<style scoped>

</style>
